import { getSize } from '@mantine/styles';

function getFontSizeValue(size, theme) {
  return getSize({ size, sizes: theme.fontSizes });
}

export { getFontSizeValue };
//# sourceMappingURL=get-font-size-value.js.map
